import { lazy } from 'react';

/** @type {Array<{ id: string, label: string, appId?: string, loader: () => Promise<unknown>, phase?: string }>} */
export const PAGE_REGISTRY = [];

let registryCounter = 0;

/**
 * Registers a route module for eager bootstrap preload and returns a React.lazy component.
 * Webpack still code-splits each static import() path; bootstrap warms the cache before mount.
 */
export function eagerLazy(loader, meta = {}) {
  const id = meta.id || `route-${registryCounter}`;
  registryCounter += 1;

  PAGE_REGISTRY.push({
    id,
    label: meta.label || 'Application module',
    appId: meta.appId,
    phase: meta.phase || 'modules',
    loader,
  });

  return lazy(loader);
}

export function resetPageRegistryForTests() {
  PAGE_REGISTRY.length = 0;
  registryCounter = 0;
}
